import React, { Component } from 'react';
import _ from 'lodash';

class ValidationTabs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    addTabs = (data) => {
        let tabs = []
        if (data.length > 0) {
            let tab1 = document.getElementsByClassName('nav-link')[0]
            if (data.length === 1 && tab1) {
                tab1.click();
            }
            data.map((item, key) => {
                tabs.push(<li className="nav-item" key={item.groupName} onClick={()=>{this.props.onTabChange(key)}}>
                    <a data-toggle="tab" className={key === this.props.tabStep ? "nav-link active show" : "nav-link"} href={`#${item.groupName}`} aria-controls={`${item.groupName}`} aria-selected="true">{item.groupName} <i className="fa fa-minus minus-icon" onClick={() => this.props.onDeletTab(item.groupName)}></i></a>
                </li>)
            })
        }
        return tabs
    }
    addTabContents = (data) => {
        let content = [];
        if (data.length > 0) {
            data.map((item, key) => {
                // console.log('data', data)
                let segments = _.orderBy(item.segments, ['orderId'], ['asc']);
                content.push(
                    <div id={item.groupName} className={key === this.props.tabStep ? "tab-pane fade show active tabContentdiv" : "tab-pane fade tabContentdiv"} role="tabpanel" key={key}>
                        <table className="table table-bordered segmentationTable">
                            <thead>
                                <tr>
                                    <th scope="col">Benefits Sought</th>
                                    {segments.map((segment,index)=>{
                                        if(index<6){
                                            return <th scope="col" key={index} >
                                                <p>Segment {index + 1} </p>
                                                <input type="text" value={segment.name} id={segment.segmentId ? segment.segmentId :segment.segmentId} onChange={(e)=>this.props.onChangeSegmentName(e,segment.groupId)}/>
                                            </th>
                                        }else{
                                            return <th scope="col" key={index} >
                                                <p>Segment {index + 1}</p>
                                                <input type="text" value={segment.name} id={segment.segmentId ? segment.segmentId :segment.segmentId} onChange={(e)=>this.props.onChangeSegmentName(e,segment.groupId)} style={{width: '80%'}}/>{index>5 && <i className="fa fa-minus minus-icon" onClick={()=>{this.props.onSegmentDelete(item.groupId,segment.segmentId)}}></i>}</th>
                                        }
                                    })}
                                    {item.segments.length<=7 && <th scope="col"><i className="fa fa-plus plusbtn plus-icon" onClick={()=>this.props.onSegmentAdd(item.groupId)}></i></th>}
                                </tr>
                            </thead>
                            <tbody>
                                {item.benefits.map((benefit,index)=>{

                                    return <tr key={index}>
                                        <td>{benefit.name}</td>
                                        {segments.map((segment,key)=>{
                                            let segmentation = _.find(item.segmentation, (i) => i.benefitId === benefit.id && i.segmentId === segment.segmentId);
                                            return segmentation ? <td key={key}>
                                                    <select className={+segmentation.value === 1 ? segmentation.segmentId + ' green-bg' : segmentation.segmentId } value={segmentation.value} id={segmentation.segmentId} onChange={(e)=>this.props.onChangeSegmentationValue(e,benefit.id,item.groupId)} style={{outline: 'none'}}>
                                                        {item.benefits.map((benefit,index)=>{
                                                            return <option key={index} value={+index+1}>{+index+1}</option>
                                                        })}
                                                    </select>
                                                </td> : null
                                        })}
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                )
            })
        }
        return content
    }
    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <ul className="nav nav-tabs ValidationTabs" role="tablist" id="myTab">
                        <li className="nav-item">
                            <a id='plusTab' onClick={() => this.props.onPlusBtn()}><i className="fa fa-plus plusbtn plus-icon"></i></a>
                        </li>
                        {this.props.tabs.length !== 0 && this.addTabs(this.props.tabs)}
                    </ul>
                    <div className="tab-content ValidationTabcontent" id="myTabContent" >
                        {this.props.tabs.length !== 0 && this.addTabContents(this.props.tabs)}
                    </div>
                </div>
            </div>
        )
    }
}

export default (ValidationTabs);



// WEBPACK FOOTER //
// ./src/components/Segmentation/ValidationMatrix/ValidationTab/ValidationTab.jsx